import {useState} from 'react';
import {ContentModalEntity} from '~/types/index';
import {ContentModal} from './ContentModal.client';
import {IconPlus} from './index';

export function SizeGuideModal({data}: {data?: ContentModalEntity}) {
  const [open, setOpen] = useState(false);

  if (!data) {
    return null;
  }

  return (
    <>
      <div className="flex justify-end pr-[13px]">
        <button
          type="button"
          className="text-16/20 font-header font-bold tracking-wider border-b-[3px] border-b-blue-500 flex items-center py-1"
          onClick={() => setOpen(true)}
        >
          SIZE GUIDE
          <IconPlus className="ml-2 w-3 h-3" />
        </button>
      </div>

      <ContentModal data={data} open={open} setOpen={setOpen} />
    </>
  );
}
